module.exports = __webpack_public_path__ + "static/media/MeteorHammer.56113680.png";